import { useState, useEffect, useMemo, useRef } from 'react'
import { isBefore } from 'date-fns'
import { useReadOnly } from 'inputs'
import { convertiDataSeServe } from 'utils'
import { useUser } from '../../../userManagement/userProvider/UserProvider'
import { isStatoAnnullatoOEliminato, isStatoChiuso } from '../../statoEntita/utilStatoEntita'

export const PERMESSI_ENTITA = {
  SOLA_LETTURA: 'r',
  LETTURA_SCRITTURA: 'w'
}

export default function usePermessiEntita(props) {
  const {
    entita,
    abilitaModificaPermessiCompleta,
    mostraPannelloVisibilita,
    readOnly_DalServer,
    condizioneReadOnly,
    stato,
    getDataCongelamento,
    descrDataCongelamento,
  } = props

  const { isUserStaff } = useUser()

  const { readOnly: readOnly_Contesto } = useReadOnly()

  const readOnly_Esterno = useMemo(() => {
    if (readOnly_DalServer || readOnly_Contesto) return true
    if (condizioneReadOnly) return condizioneReadOnly(entita)
    if (stato) return isStatoAnnullatoOEliminato(stato) || isStatoChiuso(stato)
    return false
  }, [readOnly_DalServer, readOnly_Contesto, condizioneReadOnly, entita, stato])

  // Stato che forza la visualizzazione in sola lettura
  const [readOnly, setReadOnly] = useState(readOnly_Esterno)

  useEffect(() => setReadOnly(readOnly_Esterno), [readOnly_Esterno])

  const [dataCongelamento, setDataCongelamento] = useState(() =>
    getDataCongelamento?.(entita) ?? null
  )

  function isDataDaCongelare(dataDaControllare) {
    if (!dataCongelamento || !dataDaControllare) return false
    return isBefore(convertiDataSeServe(dataDaControllare), dataCongelamento)
  }

  const entitaPiuAggiornata = useRef()
  entitaPiuAggiornata.current = entita

  function rinfrescaDataCongelamento() {
    setDataCongelamento(getDataCongelamento?.(entitaPiuAggiornata.current) ?? null)
  }

  return {
    abilitaModificaPermessiCompleta: isUserStaff() || abilitaModificaPermessiCompleta,
    mostraPannelloVisibilita,
    userNonPuoVedereEntita: false,
    readOnly,
    setReadOnly,
    dataCongelamento,
    descrDataCongelamento,
    isDataDaCongelare,
    rinfrescaDataCongelamento,
  }
}